import { debounce } from 'lodash';

import { TEXTBOX_CHANGE } from '../dropdown-state/dropdownStateActions';
import { getApiUrl, getTypedValue } from './helpers';
import { transformResponse } from './transformResponse';
import getSessionAndTrackingIdsFromCookies from '../../../utils/getSessionAndTrackingIdsFromCookies';

let searchQuerySequence = 0;
export const handleAutocompleteChange =
    value => (dispatch, getState) => {
        dispatch({
            type: TEXTBOX_CHANGE,
            payload: {
                typedValue: value,
            },
        });

        fetchAutocompleteResults(dispatch, getState);
    };

export const fetchAutocompleteResults = debounce(
    (dispatch, getState) => {
        const { sessionId, trackingId } = getSessionAndTrackingIdsFromCookies();
        const state = getState();
        const url = getApiUrl(getState, searchQuerySequence++, sessionId, trackingId);

        if (getTypedValue(state)) {
            return fetch(url)
                .then(res => res.json())
                .then(json => transformResponse(json, state))
                .catch(() => transformResponse([], state))
                .then(action => dispatch(action));
        }
    }, 250
);
